export default __webpack_public_path__ + "static/media/Bird5.43c6042a.png";